import '.a{display:flex;}.ssr-plugin'
import '.b8{gap:8px;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.a3{gap:4px;}.ssr-plugin'
import '.m{flex:1;}.ssr-plugin'
import '.f6{gap:2px;}.ssr-plugin'
import '.ji{height:184px;}.ssr-plugin'
import '.gd{overflow-y:auto;}.ssr-plugin'
import '.g8{height:32px;}.ssr-plugin'
import '.ey{flex-shrink:0;}.ssr-plugin'
import '.gq{padding:0 8px;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.a9{cursor:pointer;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import '.bl{display:grid;}.ssr-plugin'
import '.jj{grid-template-columns:repeat(7, 24px);}.ssr-plugin'
import '.fy{padding:0 4px;}.ssr-plugin'
import '.jk{place-items:center;}.ssr-plugin'
import { useState, useRef, useEffect, useCallback } from 'react'
import {
  getMonth,
  startOfWeek,
  startOfDay,
  startOfMonth,
  endOfMonth,
  addDays,
  compareAsc,
  format,
  setMonth,
  addMonths,
  startOfYear,
  setYear,
  getYear,
  isSameYear,
  isSameMonth,
  addYears,
  isSameDay,
  isToday,
  set,
} from 'date-fns'
import { Button } from '../Button/index.js'
import { radius } from '../../utils/radius.js'
import { colors } from '../../tokens/colors.js'
import { Text } from '../Text/index.js'
import { Icon } from '../Icon/index.js'
import { styled } from 'inlines'
import { IconButton } from '../IconButton/index.js'
import { Menu } from '../Menu/index.js'

export const DatePicker = ({
  value,
  placement,
  onChange,
  selectableRange,
}: {
  value?: Date
  placement?: string
  onChange: (e: any) => any
  selectableRange?: {
    min?: number | Date
    max?: number | Date
  }
}) => {
  const [view, setView] = useState('day')
  const [currentMonth, setCurrentMonth] = useState(new Date())
  const monthContainerRef = useRef<HTMLDivElement>(null)
  const yearContainerRef = useRef<HTMLDivElement>()
  const [menuOpen, setMenuOpen] = useState<'month' | 'year'>()

  let minDate: Date
  if (typeof selectableRange?.min !== 'undefined') {
    if (
      selectableRange.min instanceof Date ||
      (typeof selectableRange.min && !isNaN(selectableRange.min))
    ) {
      minDate = new Date(selectableRange?.min)
      minDate.setHours(0, 0, 0, 0)
    } else {
      console.error('minDate not a number or Date')
    }
  }
  let maxDate: Date
  if (typeof selectableRange?.max !== 'undefined') {
    if (
      selectableRange.max instanceof Date ||
      (typeof selectableRange.max && !isNaN(selectableRange.max))
    ) {
      maxDate = new Date(selectableRange?.max)
      maxDate.setHours(23, 59, 59, 999)
    } else {
      console.error('minDate not a number or Date')
    }
  }

  useEffect(() => {
    if (
      view !== 'month' ||
      !monthContainerRef.current ||
      !yearContainerRef.current
    )
      return

    monthContainerRef.current.scrollTop = (getMonth(currentMonth) - 1) * 34
    yearContainerRef.current.scrollTop = 34 * 4
  }, [view])

  const getDays = useCallback(() => {
    const days = []
    let curr = startOfWeek(startOfMonth(startOfDay(currentMonth)), {
      weekStartsOn: 1,
    })
    const end = endOfMonth(startOfDay(currentMonth))

    while (compareAsc(curr, end) < 1) {
      days.push(curr)
      curr = addDays(curr, 1)
    }

    return days
  }, [currentMonth])

  useEffect(() => {
    if (value) {
      setCurrentMonth(value)
    }
  }, [value])

  if (view === 'month') {
    return (
      <div className="a b8 i"
      >
        <styled.div>
          <div className="a a3">
            <Menu>
              <Menu.Trigger>
                <Button variant="ghost">{format(currentMonth, 'MMM')}</Button>
              </Menu.Trigger>
              <Menu.Items>
                {[...Array(12).keys()].map((monthIndex) => (
                  <Menu.ToggleItem
                    key={monthIndex}
                    label={format(setMonth(new Date(), monthIndex), 'MMM')}
                    toggled={getMonth(currentMonth) === monthIndex}
                    onChange={() =>
                      setCurrentMonth(setMonth(currentMonth, monthIndex))
                    }
                  />
                ))}
              </Menu.Items>
            </Menu>
            <Menu>
              <Menu.Trigger>
                <Button variant="ghost">{format(currentMonth, 'yyyy')}</Button>
              </Menu.Trigger>
              <Menu.Items>
                {Array.from({ length: 151 }, (_, i) => 1900 + i).map((year) => (
                  <Menu.ToggleItem
                    key={year}
                    label={year.toString()}
                    toggled={getYear(currentMonth) === year}
                    onChange={() =>
                      setCurrentMonth(setYear(currentMonth, year))
                    }
                  />
                ))}
              </Menu.Items>
            </Menu>
          </div>
        </styled.div>
        <div className="a b8">
          <div className="m a i f6 ji gd"
            ref={monthContainerRef}
          >
            {[...Array(12).keys()].map((e, i) => (
              <styled.div className="g8 ey a gq d b8 a9"
                key={i}
                style={{
                  borderRadius: radius[12],
                  '&:hover': {
                    background: colors.neutral10Adjusted,
                  },
                }}
                onClick={() => {
                  setCurrentMonth(setMonth(currentMonth, e))
                }}
              >
                {getMonth(currentMonth) === e ? (
                  <Icon variant="checkmark-normal" />
                ) : (
                  <div style={{ height: 24, width: 24 }} />
                )}
                <Text variant="display-medium">
                  {format(addMonths(startOfYear(new Date()), e), 'MMM')}
                </Text>
              </styled.div>
            ))}
          </div>
          <div className="m a i f6 ji gd"
            ref={yearContainerRef}
          >
            {[-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5].map((e, i) => (
              <styled.div className="g8 ey a gq d b8 a9"
                key={i}
                style={{
                  borderRadius: radius[12],
                  '&:hover': {
                    background: colors.neutral10Adjusted,
                  },
                }}
                onClick={() => {
                  setCurrentMonth(
                    setYear(currentMonth, getYear(new Date()) + e),
                  )
                }}
              >
                {isSameYear(
                  currentMonth,
                  addYears(startOfYear(new Date()), e),
                ) ? (
                  <Icon variant="checkmark-normal" />
                ) : (
                  <div style={{ height: 24, width: 24 }} />
                )}
                <Text variant="display-medium">
                  {format(addYears(startOfYear(new Date()), e), 'yyyy')}
                </Text>
              </styled.div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="a b8 i"
    >
      <div className="a ae d"
      >
        <div className="a f6">
          <Menu
            onOpen={() => setMenuOpen('month')}
            onClose={() => setMenuOpen(undefined)}
          >
            <Menu.Trigger>
              <Button
                variant="ghost"
                trailIcon="tiny-chevron-down"
                forceHover={menuOpen === 'month'}
              >
                {format(currentMonth, 'MMM')}
              </Button>
            </Menu.Trigger>
            <Menu.Items
              style={{
                minWidth: 120,
                width: 120,
                maxWidth: 120,
              }}
            >
              {[...Array(12).keys()].map((monthIndex) => (
                <Menu.Item
                  key={monthIndex}
                  keepOpenOnClick={false}
                  label={format(setMonth(new Date(), monthIndex), 'MMM')}
                  selected={getMonth(currentMonth) === monthIndex}
                  onClick={() =>
                    setCurrentMonth(setMonth(currentMonth, monthIndex))
                  }
                  indentContent={getMonth(currentMonth) !== monthIndex}
                />
              ))}
            </Menu.Items>
          </Menu>
          <Menu
            onOpen={() => setMenuOpen('year')}
            onClose={() => setMenuOpen(undefined)}
            autoScroll
          >
            <Menu.Trigger>
              <Button
                variant="ghost"
                trailIcon="tiny-chevron-down"
                forceHover={menuOpen === 'year'}
              >
                {format(currentMonth, 'yyyy')}
              </Button>
            </Menu.Trigger>
            <Menu.Items
              style={{
                minWidth: 120,
                width: 120,
                maxWidth: 120,
              }}
            >
              {Array.from({ length: 151 }, (_, i) => 1900 + i).map((year) => (
                <Menu.Item
                  key={year}
                  keepOpenOnClick={false}
                  label={year.toString()}
                  selected={getYear(currentMonth) === year}
                  onClick={() => setCurrentMonth(setYear(currentMonth, year))}
                  indentContent={getYear(currentMonth) !== year}
                />
              ))}
            </Menu.Items>
          </Menu>
        </div>
        <div className="a f6">
          <IconButton
            size="small"
            icon="chevron-left"
            onClick={() => {
              setCurrentMonth(addMonths(currentMonth, -1))
            }}
            tooltip="Previous month"
          />
          <IconButton
            size="small"
            icon="chevron-right"
            onClick={() => {
              setCurrentMonth(addMonths(currentMonth, 1))
            }}
            tooltip="Next month"
          />
        </div>
      </div>
      <div className="bl jj b8 fy jk"
        style={{
          gridTemplateRows: placement?.includes('top')
            ? 'repeat(7, 24px)'
            : '24px',}}
      >
        {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((e, i) => (
          <Text key={i} variant="subtext-regular" color="neutral20">
            {e}
          </Text>
        ))}
        {getDays().map((e) =>
          isSameMonth(currentMonth, e) ? (
            <Button
              style={{
                textAlign: 'center',
                '& div': { flex: 0, justifyContent: 'center' },
              }}
              key={e.getTime()}
              size="small"
              width="full"
              singleLine={false}
              variant={
                isSameDay(value, e) ? 'fill' : isToday(e) ? 'border' : 'ghost'
              }
              disabled={(minDate && e < minDate) || (maxDate && e > maxDate)}
              onClick={() => {
                onChange(
                  set(value ?? new Date(), {
                    year: e.getFullYear(),
                    month: e.getMonth(),
                    date: e.getDate(),
                  }),
                )
              }}
            >
              {format(e, 'd')}
            </Button>
          ) : (
            <div key={e.getTime()} />
          ),
        )}
      </div>
    </div>
  )
}
